import { Text } from '@servicetitan/anvil2';
import { Button, ButtonGroup, Modal } from '@servicetitan/design-system';
import { useOutboundCallerIdTableContext } from '../context';
import { OutboundCallerIdTable } from '../OutboundCallerIdTable';
import styles from './OutboundCallerIdModal.module.css';
import { useEffect, useRef } from 'react';

export const OutboundCallerIdModal = ({
  onClose,
  onDone,
}: {
  onClose: () => void;
  onDone: (selectedItem: any) => void;
}) => {
  const {
    table: { selectedItem },
    tenantName,
    loading,
  } = useOutboundCallerIdTableContext();

  const componentRef = useRef(null);

  // Workaround Hide other modals when this modal is open
  useEffect(() => {
    const modals = document.querySelectorAll<HTMLElement>('.Overlay');

    const hiddenModals: { element: HTMLElement; originalDisplay: string }[] =
      [];

    modals.forEach((modal) => {
      if (componentRef.current && !modal.contains(componentRef.current)) {
        hiddenModals.push({
          element: modal,
          originalDisplay: modal.style.display,
        });
        modal.style.display = 'none';
      }
    });

    return () => {
      hiddenModals.forEach(({ element, originalDisplay }) => {
        element.style.display = originalDisplay || '';
      });
    };
  }, []);

  return (
    <Modal
      open={true}
      focusTrapOptions={{ disabled: true }}
      title={'Change Outbound Caller ID'}
      className={styles.outboundCallIdModal}
      footer={
        <ButtonGroup className={styles.footer}>
          <Button onClick={onClose}>Back</Button>
          <Button
            primary
            onClick={() => {
              onDone(selectedItem);
            }}
            disabled={loading || !selectedItem}
          >
            Done
          </Button>
        </ButtonGroup>
      }
    >
      <div className={styles.modalContainer} ref={componentRef}>
        {tenantName && (
          <Text className={styles.subTitle} size='medium' subdued>
            Select a {tenantName} Caller ID Number, or your direct line.
          </Text>
        )}
        <OutboundCallerIdTable />
      </div>
    </Modal>
  );
};
